export class ForgeProjectPublishedState {
    constructor(model) {
        this.userId = model.userId;
        this.lastPublishedAt = new Date(model.lastPublishedAt);
        this.iterationId = model.iterationId;
        this.hideSupernovaUI = model.hideSupernovaUI;
        this.visibility = model.visibility;
    }
    toRemote() {
        return {
            ...this,
            lastPublishedAt: this.lastPublishedAt.toISOString(),
        };
    }
}
